/* ============ */
/*   APP.JS     */
/* ============ */

import { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
/*import { useAuth } from './context/AuthContext';*//*comentado porque ya no uso login*/

import Navbar from "./components/Navbar";
import WelcomeSection from "./components/WelcomeSection";
import AboutSection from "./components/AboutSection";
import Colaboraciones from "./components/Colaboraciones";
import Footer from "./components/Footer";
import ProjectSection from "./components/ProjectSection";
import PoliticaPrivacidad from './components/footer-pages/PoliticaPrivacidad';
import UsoCookies from './components/footer-pages/UsoCookies';
import CondicionesUso from './components/footer-pages/CondicionesUso';
import AvisosLegales from './components/footer-pages/AvisosLegales';
import MapaSitio from './components/footer-pages/MapaSitio';
import NeuroGlintPage from './components/NeuroGlintPage';
import MoveSparkPage from './components/MoveSparkPage';
import ScrollToTop from './components/ScrollToTop';
import BackToTopButton from "./components/BackToTopButton";
import ContactView from './contact/ContactView';
import MasAlla from './components/MasAlla';
import SparklingSocial from './components/SparklingSocial';
import SocialMediaWall from './components/social/SocialMediaWall';
import CustomCookieConsent from './components/CustomCookieConsent';
import HomeProjects from './components/HomeProjects';
import HomeImpact from './components/HomeImpact';
import { TeamSection } from './components/TeamSection';
import FloatingLines from './components/FloatingLines';

import "./components/Navbar.css";
import "./components/WelcomeSection.css";
import "./components/Footer.css";
import "./App.css";

/* =========  Protege la ruta /admin ========== */
/*const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" />;
};*/

function AppContent() {
  const location = useLocation();

  const isHome = location.pathname === "/";


  return (
    <div style={{ paddingTop: isHome ? "0px" : "70px" }}>
      <Navbar />

      <Routes>
        {/* Home */}
        <Route
          path="/"
          element={
            <>
              <WelcomeSection />
              <HomeImpact />
              <HomeProjects />
              <TeamSection />
              <Colaboraciones />
            </>
          }
        />

        {/* Páginas informativas */}
        <Route path="/about" element={<AboutSection />} />
        <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
        <Route path="/uso-cookies" element={<UsoCookies />} />
        <Route path="/condiciones-de-uso" element={<CondicionesUso />} />
        <Route path="/avisos-legales" element={<AvisosLegales />} />
        <Route path="/mapa-sitio" element={<MapaSitio />} />

        {/* Proyectos */}
        <Route path="/projects" element={<ProjectSection />} />
        <Route path="/projects/neuroglint" element={<NeuroGlintPage />} />
        <Route path="/movespark" element={<MoveSparkPage />} />

        {/* Otros */}
        <Route path="/contacto" element={<ContactView />} />
        <Route path="/mas-alla-del-id" element={<MasAlla />} />
        <Route path="/sparkling-social" element={<SparklingSocial />} />

        {/* Blog / Social Media Wall */}
        <Route path="/nuestras-redes" element={<SocialMediaWall />} />

      {/* { Auth / Admin }
      <Route path="/login" element={<LoginForm />} /> */} {/* Esto se eliminó porque no importaba cómo se modificara la tabla de usuario, no se actualizaba. */}

{/*<Route
  path="/admin"
  element={
    <ProtectedRoute>
      <BlogForm />
    </ProtectedRoute>
  }
/>

<Route
  path="/admin/:id"
  element={
    <ProtectedRoute>
      <BlogForm />
    </ProtectedRoute>
  }
/>*/}

      </Routes>

        {/*Consentimiento de cookies*/}
<CustomCookieConsent />

      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <BackToTopButton />
      <AppContent />
    </Router>
  );
}

export default App;
